import { useEffect } from 'react';
import { initForegroundFcmListener } from './utils/webPush';
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom';
import './App.css';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import Home from './pages/Home';
import ProfilePage from './pages/ProfilePage';
import ProfileEditPage from './pages/ProfileEditPage';
import ProfilePasswordPage from './pages/ProfilePasswordPage';
import ProfileAddressesPage from './pages/ProfileAddressesPage';
import ProfileContactsPage from './pages/ProfileContactsPage';
import ProfileSubscriptionsPage from './pages/ProfileSubscriptionsPage';
import PrivateRoute from './components/Routes/PrivateRoute';
import PublicRoute from './components/Routes/PublicRoute';
import AdminRoute from './components/Routes/AdminRoute';
import { useAppDispatch, useAppSelector } from './store/store';
import AuthAction from './store/auth/action';
import UserProfile from './pages/UserProfile';
import AdminHome from './pages/AdminHome';
import ClothesByCategory from './pages/ClothesByCategory';
import ClothesDetail from './pages/ClothesDetail';
import FavoritesPage from './pages/FavoritesPage';
import MyPostsPage from './pages/MyPostsPage';
import MyPostAddPage from './pages/MyPostAddPage';
import MyPostEditPage from './pages/MyPostEditPage';
import ArticlesPage from './pages/ArticlesPage';
import ProfileOrdersPage from './pages/ProfileOrdersPage';
import CreateOrderPage from './pages/CreateOrderPage';
import OrderPage from './pages/OrderPage';
import SellerProfile from './pages/SellerProfile';
import ContactPage from './pages/ContactPage';

function App() {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(state => state.auth);
  const isAuth = !!user;
  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    const unsubscribe = AuthAction.listenForAuthState(dispatch);
    return () => unsubscribe();
  }, [dispatch]);

  useEffect(() => {
    initForegroundFcmListener();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<PublicRoute isAuthenticated={isAuth}><SignIn /></PublicRoute>} />
        <Route path="/signup" element={<PublicRoute isAuthenticated={isAuth}><SignUp /></PublicRoute>} />
        <Route path="/forgot-password" element={<PublicRoute isAuthenticated={isAuth}><ForgotPassword /></PublicRoute>} />

        {/* Public: no login required */}
        <Route path="/home" element={<Home />} />
        <Route path="/category/:type" element={<ClothesByCategory />} />
        <Route path="/item" element={<ClothesDetail />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/seller/:id" element={<SellerProfile />} />

        {/* Private: login required (Profile, My Posts, Post products, Orders) */}
        <Route path="/my-posts" element={<PrivateRoute isAuthenticated={isAuth}><MyPostsPage /></PrivateRoute>} />
        <Route path="/my-posts/add" element={<PrivateRoute isAuthenticated={isAuth}><MyPostAddPage /></PrivateRoute>} />
        <Route path="/my-posts/edit" element={<PrivateRoute isAuthenticated={isAuth}><MyPostEditPage /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute isAuthenticated={isAuth}><ProfilePage /></PrivateRoute>} />
        <Route path="/profile/edit" element={<PrivateRoute isAuthenticated={isAuth}><ProfileEditPage /></PrivateRoute>} />
        <Route path="/profile/password" element={<PrivateRoute isAuthenticated={isAuth}><ProfilePasswordPage /></PrivateRoute>} />
        <Route path="/profile/addresses" element={<PrivateRoute isAuthenticated={isAuth}><ProfileAddressesPage /></PrivateRoute>} />
        <Route path="/profile/contacts" element={<PrivateRoute isAuthenticated={isAuth}><ProfileContactsPage /></PrivateRoute>} />
        {/* <Route path="/profile/subscriptions" element={<PrivateRoute isAuthenticated={isAuth}><ProfileSubscriptionsPage /></PrivateRoute>} /> */}
        {/* <Route path="/orders" element={<PrivateRoute isAuthenticated={isAuth}><ProfileOrdersPage /></PrivateRoute>} />
        <Route path="/order/create" element={<PrivateRoute isAuthenticated={isAuth}><CreateOrderPage /></PrivateRoute>} />
        <Route path="/order/detail" element={<PrivateRoute isAuthenticated={isAuth}><OrderPage /></PrivateRoute>} /> */}

        <Route path="/admin" element={<PrivateRoute isAuthenticated={isAuth}><AdminRoute isAdmin={isAdmin}><AdminHome /></AdminRoute></PrivateRoute>} />
        <Route path="/user" element={<PrivateRoute isAuthenticated={isAuth}><AdminRoute isAdmin={isAdmin}><UserProfile /></AdminRoute></PrivateRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
